"use client";
import { jsxs as a, jsx as i } from "react/jsx-runtime";
const d = ({
  title: l,
  titleId: t,
  desc: e,
  descId: h,
  ...r
}) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "flag-icons-gg",
    viewBox: "0 0 640 480",
    "aria-labelledby": t,
    "aria-describedby": h,
    ...r,
    children: [
      e ? /* @__PURE__ */ i("desc", { id: h, children: e }) : null,
      l ? /* @__PURE__ */ i("title", { id: t, children: l }) : null,
      /* @__PURE__ */ i("path", { fill: "#fff", d: "M0 0h640v480H0z" }),
      /* @__PURE__ */ i("path", { fill: "#e8112d", d: "M256 0h128v480H256z" }),
      /* @__PURE__ */ i("path", { fill: "#e8112d", d: "M0 176h640v128H0z" }),
      /* @__PURE__ */ i(
        "path",
        {
          id: "gg-a",
          fill: "#f9dd16",
          d: "m110 286.7 23.3-23.4h210v-46.6h-210L110 193.3z"
        }
      ),
      /* @__PURE__ */ i(
        "use",
        {
          xlinkHref: "#gg-a",
          width: 36,
          height: 24,
          transform: "rotate(90 320 240)"
        }
      ),
      /* @__PURE__ */ i(
        "use",
        {
          xlinkHref: "#gg-a",
          width: 36,
          height: 24,
          transform: "rotate(-90 320 240)"
        }
      ),
      /* @__PURE__ */ i(
        "use",
        {
          xlinkHref: "#gg-a",
          width: 36,
          height: 24,
          transform: "rotate(180 320 240)"
        }
      )
    ]
  }
);
export {
  d as default
};
